import React, { ReactElement } from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { MOON_SVG } from "../utils/svgs";

interface Props {
  isOvernight: boolean;
}

export function Overnight(props: Props): ReactElement {
  if (!props.isOvernight) {
    return <></>;
  }

  return (
    <div className="Overnight">
      {MOON_SVG}
      <span>{translate(STRINGS.OVER_NIGHT)}</span>
    </div>
  );
}
